import StyledLink from '../StyledLink'
import {
  ADD,
  ENVIRONMENTS
} from '../routes'
import type { Props } from '../types'

const LinkToAddEnvironment = ({
  children,
  isHyperlink
}: Props) => {
  const toUrl = `/${ENVIRONMENTS}/${ADD}`

  return (
    <StyledLink
      isHyperlink={isHyperlink}
      to={toUrl}
    >
      {children}
    </StyledLink>
  )
}

export default LinkToAddEnvironment
